/* eslint-disable prefer-destructuring */
import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { message } from 'antd';
import { times } from '@/utils/calc-fns';
import { getSubShopListByIds } from './SetMeals/service';

const model = {
  state: {
    dataList: [],
    pageTotal: 0,
    queryParams: {
      pageSize: 10,
      page: 1,
      company_class: null,
      sub_company_name: null,
      welfare_status: null,
      status: null,
      showTest: 0,
    },
    list: [],
    listLoading: false,
    listTotal: 0,

    item: {}, // 公司信息 不明白为什么要起这个名字
    itemLoading: false,

    // 是否是编辑
    isEdit: false,
    // 是子公司还是企业
    isSubCompany: false,
    // 审核意见是通过
    auditResult: true,
    // 关闭福利餐弹窗
    welfareModal: {
      visible: false,
      num: null,
    },
    // 确认充值弹窗
    confirmRechargeVisible: false,
    allowanceType: 2,
    // 结算信息弹窗
    settleModalVisibel: false,
    defaultCompanyStatus: {},

    // auv设备列表id
    auvList: [{ key: 0 }],
    // auv列表是否填写完成
    auvListIsAllSuccess: true,
    company_address_new: [],
    auvDevice: {}, // auv设备列表餐段加热等
    threePartiesDockingFormInit: null,
    isModalVisible: false,
  },
  reducers: {
    setState(state, partialState) {
      return {
        ...state,
        ...partialState,
      };
    },
  },
  actions: ({ dispatch: { CompanyManage, basic }, getState }) => ({
    setIsModalVisible(val) {
      CompanyManage.setState({ isModalVisible: val });
    },
    // 处理存餐模式选择
    handleCabinetPattern(val) {
      CompanyManage.setState({ cabinetMode: val });
    },
    // 获取列表
    async getList() {
      CompanyManage.setState({
        listLoading: true,
      });
      const { queryParams } = getState().CompanyManage;
      const { createTime, ...params } = queryParams;
      if (createTime && createTime[0] && createTime[1]) {
        params.createTimeBegin = times(createTime[0].unix(), 1000);
        params.createTimeEnd = times(createTime[1].unix(), 1000);
      }
      if (params.location) {
        if (params.location[0]) {
          params.provinceCode = params.location[0];
        }
        if (params.location[1]) {
          params.cityCode = params.location[1];
        }
        if (params.location[2]) {
          params.areaCode = params.location[2];
        }
        delete params.location;
      }

      const data = await fetch('/saasmerchant/web/fscompany/getFsCompanyList', {
        params: filterNull({
          ...params,
          showTest: params?.showTest || 0,
          notCooperationStatus: 1,
        }),
        type: 'POST',
        useJson: true,
      });
      CompanyManage.setState({
        listLoading: false,
      });
      if (data) {
        CompanyManage.setState({
          list: data.companyVos || [],
          listTotal: data.total || 0,
          companySumTotal: data.companySumTotal || 0,
          total: data.total || 0,
          ratio: data.ratio || 0,
        });
      }
      return data;
    },
    async editItem(params) {
      const { union_shop_id } = getState().basic;
      const newParams = filterNull({
        ...params,
        union_shop_id,
      });
      const data = await fetch('/company/manage/companyedit', {
        params: newParams,
        type: 'POST',
      });
      return data;
    },

    // 搜索
    onSearch(queryParams) {
      CompanyManage.setState({
        queryParams,
      });
      CompanyManage.getList();
    },
    // 底部换页
    onNav(page) {
      const { queryParams } = getState().CompanyManage;
      CompanyManage.setState({
        queryParams: {
          ...queryParams,
          page,
        },
      });
      CompanyManage.getList();
    },
    // 重置筛选项
    onReset() {
      CompanyManage.setState({
        queryParams: {
          pageSize: 10,
          page: 1,
          companyClass: null,
          subCompanyName: null,
          welfareStatus: null,
          status: null,
        },
      });
    },
    onListSizeChange(current, pageSize) {
      const { queryParams } = getState().CompanyManage;
      CompanyManage.setState({
        queryParams: {
          ...queryParams,
          pageSize,
        },
      });
      CompanyManage.getList();
    },

    // 企业状态停用、启用
    async postChangeStatus(params) {
      const data = await fetch('/saasmerchant/web/fscompany/setCompanySwitch', {
        type: 'POST',
        params: filterNull(params),
        useJson: true,
      });
      if (data) {
        CompanyManage.getList();
      }
      return data;
    },

    // 企业管理导出
    async exportCompany(values) {
      const { createTime, ...params } = values;
      if (createTime && createTime[0] && createTime[1]) {
        params.createTimeBegin = times(createTime[0].unix(), 1000);
        params.createTimeEnd = times(createTime[1].unix(), 1000);
      }
      if (params.location) {
        if (params.location[0]) {
          params.provinceCode = params.location[0];
        }
        if (params.location[1]) {
          params.cityCode = params.location[1];
        }
        if (params.location[2]) {
          params.areaCode = params.location[2];
        }
        delete params.location;
      }
      const data = await fetch('/saasmerchant/web/fscompany/exportCompanyList', {
        type: 'POST',
        useJson: true,
        params: {
          ...params,
          notCooperationStatus: 1,
        },
      });
      if (data) {
        if (data) {
          message.success('导出成功');
          basic.setLogListDot(true);
        }
      }
    },

    async companyCouponExchange(params) {
      const data = await fetch('/saasmerchant/web/couponOrder/companyCouponExchange', {
        useJson: true,
        type: 'POST',
        params,
      });
      if (data) {
        message.success('切换成功');
      }
      return data;
    },
    async increaseQrCode(params) {
      const data = await fetch('/saasmerchant/web/fscompany/external_docking/qr_code/addQrCode', {
        useJson: true,
        type: 'POST',
        params,
      });
      return data;
    },
    async getQrCodeList(params) {
      const data = await fetch(
        '/saasmerchant/web/fscompany/external_docking/qr_code/getQrCodeList',
        {
          type: 'GET',
          params,
        },
      );
      if (params.exportFlag === 1) {
        basic.setLogListDot(true);
        return data;
      }
      CompanyManage.setState({
        dataList: data.list,
        pageTotal: data.total,
      });
      return data;
    },
    async getQueryConfigByCompanyId(params) {
      const data = await fetch(
        '/saasmerchant/web/fscompany/external_docking/company_platform/getConfigByCompanyId',
        {
          type: 'GET',
          params,
        },
      );
      if (data === null) {
        CompanyManage.setState({
          threePartiesDockingFormInit: true,
        });
      } else {
        CompanyManage.setState({
          threePartiesDockingFormInit: [data],
        });
      }
      return data;
    },
    async getIdPlatform(params) {
      const data = await fetch(
        '/saasmerchant/web/fscompany/external_docking/company_platform/addConfig',
        {
          type: 'POST',
          params,
          useJson: true,
        },
      );
      return data;
    },
    async getPaymentWayIdList(params) {
      const data = await fetch(
        '/saasmerchant/web/fscompany/external_docking/company_platform/getPaymentWayIdList',
        {
          type: 'GET',
          params,
        },
      );
      return data;
    },
    async deleteQrCode(params) {
      const data = await fetch(
        '/saasmerchant/web/fscompany/external_docking/qr_code/deleteQrCode',
        {
          type: 'POST',
          params,
          useJson: true,
        },
      );
      return data;
    },
    async getIdPlatformeditConfig(params) {
      const data = await fetch(
        '/saasmerchant/web/fscompany/external_docking/company_platform/editConfig',
        {
          type: 'POST',
          params,
          useJson: true,
        },
      );
      return data;
    },
    async getShopListByName(params) {
      const data = await fetch('/saasmerchant/web/bms/business/shop/listV2', {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },
    async companyBirthdayWelfare(params) {
      const data = await fetch('/saasmerchant/web/fscompany/updateBirthdayWelfareStatus', {
        useJson: true,
        type: 'POST',
        params,
      });
      if (data) {
        message.success('切换成功');
      }
      return data;
    },
    async getListData(params) {
      const data = await fetch('/saasmerchant/web/fscompany/getFsCompanyList', {
        params: filterNull({
          ...params,
          notCooperationStatus: 1,
        }),
        type: 'POST',
        useJson: true,
      });
      return data;
    },
    async setShowRecommendCompanyStatus(params) {
      const data = await fetch('/saasmerchant/web/fscompany/setShowRecommendCompanyStatus', {
        useJson: true,
        params,
      });
      if (data) {
        message.success('切换成功');
      }
      return data;
    },
    async setShowCustomerGroupStatus(params) {
      const data = await fetch('/saasmerchant/web/fscompany/setShowCustomerGroupStatus', {
        useJson: true,
        params,
      });
      if (data) {
        message.success('切换成功');
      }
      return data;
    },
    // isEdit设置
    onIsEditChange(isEdit) {
      CompanyManage.setState({
        isEdit,
      });
    },
    // isSubCompany设置
    onIsSubCompanyChange(isSubCompany) {
      CompanyManage.setState({
        isSubCompany,
      });
    },
    onAuditResultChange(auditResult) {
      CompanyManage.setState({
        auditResult,
      });
    },

    // 获取企业基础信息+企业地址列表（新java替换php）
    async getAddressList(companyId) {
      const { union_shop_id } = getState().basic;
      CompanyManage.setState({
        itemLoading: true,
      });
      const res1 = await fetch('/saasmerchant/web/fscompany/getCompanyInfoVO', {
        params: filterNull({
          company_id: companyId,
          union_shop_id: union_shop_id,
          companyId: +companyId,
          unionShopId: union_shop_id,
        }),
        type: 'POST',
        // useJson: true,
      });
      const res2 = await fetch('/saasmerchant/web/fscompany/address/list', {
        params: filterNull({
          companyId,
        }),
        type: 'GET',
      });
      Promise.all([res1, res2])
        .then((res) => {
          const [companyinfo, addressListFscompany] = res;
          if (companyinfo && addressListFscompany) {
            CompanyManage.setState({
              item: { ...companyinfo, company_address_new: addressListFscompany },
            });
          } else {
            CompanyManage.setState({
              item: { companyId: companyId },
            });
          }
          CompanyManage.setState({
            itemLoading: false,
          });
        })
        .finally(() => {
          CompanyManage.setState({
            itemLoading: false,
          });
        });
    },

    // 新增企业地址（新java替换php）
    async addressSave(params) {
      const data = await fetch('/saasmerchant/web/fscompany/address/save', {
        params: filterNull({
          ...params,
        }),

        useJson: true,
        type: 'POST',
      });
      return data;
    },

    // 编辑企业地址（新java替换php）
    async addressUpdate(params) {
      const data = await fetch('/saasmerchant/web/fscompany/address/update', {
        params: filterNull({
          ...params,
        }),
        useJson: true,
        type: 'POST',
      });
      return data;
    },

    // 删除企业地址（新java替换php）
    async addressDelete(params) {
      const data = await fetch('/saasmerchant/web/fscompany/address/delete', {
        params,
        type: 'GET',
        useJson: true,
      });
      return data;
    },

    // 重置密码
    async resetPassword(passport_id, callback) {
      const { union_shop_id } = getState().basic;
      const params = filterNull({
        passport_id,
        union_shop_id,
      });
      const data = await fetch('/company/account/restpassword', {
        params,
        type: 'POST',
      });
      if (data) {
        const { item } = getState().CompanyManage;
        CompanyManage.setState({
          item: {
            ...item,
            init_password: data.init_password,
          },
        });
        if (callback) {
          callback(data.init_password);
        }
      }
      return data;
    },
    // 更新福利餐设置、用户端设置
    async updateConfig(companyId, params, getAllResponseData = false) {
      const data = await fetch('/saasmerchant/web/fscompany/updateConfig', {
        type: 'POST',
        useJson: true,
        params: {
          companyId,
          ...params,
        },
        getAllResponseData,
      });
      return data;
    },
    // 开关福利餐
    async switchWelfareStatus(companyId, status) {
      const data = await fetch('/saasmerchant/fsarea/company/switchCompanyWelfareStatus', {
        type: 'POST',
        useJson: true,
        params: {
          companyId,
          welfareStatus: Number(status),
        },
      });
      if (data) {
        if (!data.result) {
          // 存在预约单无法关闭，弹窗提示
          if (!status && data.unCompleteOrder > 0) {
            CompanyManage.setState({
              welfareModal: {
                visible: true,
                num: data.unCompleteOrder,
              },
            });
          } else if (!status) {
            message.error('关闭福利餐失败');
          } else {
            message.error('开通福利餐失败');
          }
        }
      } else {
        message.error('设置失败');
      }
      return data;
    },
    onWelfareModalChange(visible, num) {
      CompanyManage.setState({
        welfareModal: {
          visible,
          num,
        },
      });
    },
    async getSettlementDetail(params) {
      const data = await fetch('/saasmerchant/fsarea/invoice/settlement/get', {
        params,
      });
      return data;
    },
    async submitSettlementSettings(params) {
      const data = await fetch('/saasmerchant/fsarea/invoice/settlement/set', {
        params,
        useJson: true,
        type: 'POST',
        getAllResponseData: true,
      });
      return data;
    },
    async getGDInvoiceInfo(params) {
      const GDListData = await fetch('/saasmerchant/pcweb/invoice/tool/title/search', {
        params,
      });
      return GDListData || [];
    },
    async getChildCompany(params) {
      const GDListData = await fetch('/company/subcompany/subcompanygetlist', {
        type: 'POST',
        params,
      });
      return GDListData || [];
    },
    // 员工扫码认证
    async updateCompanyQrStatus(companyId, status) {
      const data = await fetch('/saasmerchant/web/fscompany/updateCompanyQrCodeStatus', {
        type: 'POST',
        useJson: true,
        params: {
          companyId,
          qrCodeStatus: Number(status),
        },
      });
      if (data) {
        status ? message.success('开启员工扫码认证成功') : message.success('关闭员工扫码认证成功');
      } else {
        message.error('设置失败');
      }
      return data;
    },

    // 请求员工认证的二维码
    async handleDownloadQrCode(params) {
      const dataUrl = await fetch('/saasmerchant/web/fscompany/getCompanyQrCode', {
        type: 'POST',
        useJson: true,
        params,
      });
      return dataUrl;
    },
    // 更新是否隐藏到店自提状态
    async updateShopTakeStatus(companyId, status) {
      const data = await fetch('/saasmerchant/web/fscompany/updateShopTakeHiddenStatusById', {
        useJson: true,
        params: {
          companyId,
          status: Number(!status),
        },
      });
      if (data) {
        status ? message.success('已开启自提') : message.success('已关闭自提');
      } else {
        message.error('设置失败');
      }
      return data;
    },
    // 查询其他配置中的各种状态
    async getCompanyStatus(id) {
      const data = await fetch('/saasmerchant/web/fscompany/getFlagsById', {
        params: {
          companyId: id,
        },
      });
      if (data) {
        // 获取店铺详情列表
        if (data.shopTakeCancel?.subShopIdList?.length) {
          const subShopIdList = await getSubShopListByIds({
            companyId: id,
            subShopIds: data.shopTakeCancel.subShopIdList,
          });
          data.shopTakeCancel.subShopIdList = subShopIdList;
        }
        CompanyManage.setState({ defaultCompanyStatus: data });
      } else {
        message.error('获取企业信息失败');
      }
      return data;
    },
    // 切换结算管理方式
    setAllowanceType(allowanceType) {
      CompanyManage.setState({
        allowanceType,
      });
    },
    // 获取结算管理的状态
    async getAllowanceType(params) {
      const { union_shop_id } = getState().basic;
      const { company_id } = params;
      const data = await fetch('/saasmerchant/fsarea/company/allowanceInfo', {
        params: {
          unionShopId: union_shop_id,
          companyId: company_id,
        },
      });
      if (data) {
        CompanyManage.setState({
          allowanceType: data.allowanceType,
        });
      }
      return data;
    },
    // 勿删
    async updatePriceLimitById(params) {
      const data = await fetch('saasmerchant/web/fscompany/updatePriceLimitById', {
        type: 'POST',
        useJson: true,
        params: {
          ...params,
        },
      });
      return data;
    },

    async switchCompanyIsAlone(params) {
      const data = await fetch('/saasmerchant/fsarea/company/switchCompanyIsAlone', {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },
    async switchChangePassword(params) {
      const data = await fetch('/saasmerchant/web/fscompany/updateNeedChangePassword', {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },
    // 打开结算信息弹窗
    setSettleModalVisibel() {
      const { settleModalVisibel } = getState().CompanyManage;
      CompanyManage.setState({
        settleModalVisibel: !settleModalVisibel,
      });
    },
    // 关闭、打开确认充值弹窗
    setConfirmRechargeVisible() {
      const { confirmRechargeVisible } = getState().CompanyManage;
      CompanyManage.setState({
        confirmRechargeVisible: !confirmRechargeVisible,
      });
    },
    // // 开启用餐短信提醒
    // async updateMessageRemind(params) {
    //   const data = await fetch('/saasmerchant/fsarea/company/enableMealRemind', {
    //     type: 'POST',
    //     useJson: true,
    //     params,
    //   });
    //   return data;
    // },
    // 设置
    async updateBalanceRemind(params) {
      const { union_shop_id } = getState().basic;
      const data = await fetch('/saasmerchant/web/fscompany/updateBalanceRemind', {
        type: 'POST',
        useJson: true,
        params: {
          unionShopId: union_shop_id,
          ...params,
        },
      });
      return data;
    },
    // 获取企业菜品过滤标准列表
    async getDiningstandardList(params) {
      const data = await fetch('/saasmerchant/web/fscompany/diningstandard/list', {
        params,
      });
      return data;
    },
    // 编辑企业菜品过滤标准
    async saveDiningstandard(params) {
      const url = params.standardId
        ? '/saasmerchant/web/fscompany/diningstandard/update'
        : '/saasmerchant/web/fscompany/diningstandard/save';
      const data = await fetch(url, {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },
    // 删除企业菜品过滤标准
    async delDiningstandard(params) {
      const data = await fetch('/saasmerchant/web/fscompany/diningstandard/delete', {
        params,
      });
      return data;
    },
    setAuvList(list) {
      CompanyManage.setState({
        auvList: list,
      });
    },

    // 设置设备列表餐段加热数据
    setAuvDevice(list) {
      CompanyManage.setState({
        auvDevice: list,
      });
    },
    // 校验auv设备弹窗信息是否填写完整
    setAuvListIsAllSuccess(flag) {
      CompanyManage.setState({
        auvListIsAllSuccess: flag,
      });
    },
    // 获取定位标识下拉列表
    async getAddressMarkerList(companyId) {
      const data = await fetch('/saasmerchant/web/address/dock/list', {
        params: {
          companyId,
        },
      });
      return data;
    },
    // 获取企业地址下拉列表
    async getCompanyAddressList(companyId) {
      const data = await fetch('/saasmerchant/web/address/list', {
        params: {
          companyId,
        },
      });
      return data;
    },
    // 新增映射关系
    async addRelationAddress(params) {
      const data = await fetch('/saasmerchant/web/address/dockrelation/save', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        message.success('保存成功');
      }
      return data;
    },
    // 编辑映射关系
    async updateRelationAddress(params) {
      const data = await fetch('/saasmerchant/web/address/dockrelation/update', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        message.success('保存成功');
      }
      return data;
    },
    // 获取映射关系列表
    async getRelationList(companyId) {
      const data = await fetch('/saasmerchant/web/address/dockrelation/list', {
        params: {
          companyId,
        },
      });
      return data;
    },
    // 删除映射关系列表
    async deleteRelationAddress(companyId, relationId) {
      const data = await fetch('/saasmerchant/web/address/dockrelation/delete', {
        params: {
          companyId,
          relationId,
        },
      });
      if (data) {
        message.success('已删除本条映射关系');
      }
      return data;
    },

    // 保存飞书映射appid
    async setThirdPart(params) {
      const data = await fetch('/saasmerchant/web/fscompany/thirdPartSet', {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },
    // 获取飞书映射appid
    async getThirdPart(companyId) {
      const data = await fetch('/saasmerchant/web/fscompany/thirdPartGet', {
        type: 'GET',
        params: {
          companyId,
        },
      });
      return data;
    },
    async getAllUser(companyId) {
      const data = await fetch('/saasmerchant/web/fscompany/thirdPartSyn', {
        type: 'POST',
        useJson: true,
        params: {
          companyId,
        },
      });
      return data;
    },
    // 新增子企业映射配置关系
    async addCompanyRelation(params) {
      const data = await fetch('/saasmerchant/web/fscompany/dockrelation/save', {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },
    // 更新子企业映射配置关系
    async updateCompanyRelation(params) {
      const data = await fetch('/saasmerchant/web/fscompany/dockrelation/update', {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },
    // 获取子企业映射配置列表
    async getComRelationList(parentCompanyId) {
      const data = await fetch('/saasmerchant/web/fscompany/dockrelation/list', {
        type: 'GET',
        params: {
          parentCompanyId,
        },
      });
      return data;
    },
    // 删除子企业映射配置
    async deleteCompanyRelation(params) {
      const data = await fetch('/saasmerchant/web/fscompany/dockrelation/delete', {
        type: 'GET',
        params,
      });
      return data;
    },
    async setComplaintStatus(params) {
      const data = await fetch('saasmerchant/web/fscompany/updateComplaintSwitch', {
        type: 'GET',
        params,
      });
      return data;
    },
    // 设置子企业限购/餐段
    async updateCompanyLimit(companyId, params) {
      const data = await fetch('/saasmerchant/web/fscompany/updateConfigCompanyLimit', {
        type: 'POST',
        useJson: true,
        params: {
          companyId,
          ...params,
        },
      });
      return data;
    },
    // 获取企业是否可以提前下单
    async getAppoinmentTimeById(params) {
      const data = await fetch('/saasmerchant/web/fscompany/getAppoinmentTimeById', {
        type: 'GET',
        params: { companyId: params },
      });
      return data;
    },

    // 企业配置更改 业务及支付设置
    async updateBusinessFlag(companyId, params) {
      const data = await fetch('/saasmerchant/web/fscompany/updateBusinessFlag', {
        type: 'POST',
        useJson: true,
        params: {
          companyId,
          ...params,
        },
      });
      return data;
    },

    // 企业新增配置 用户端显示设置
    async updateUserShowFlag(companyId, params) {
      const data = await fetch('/saasmerchant/web/fscompany/updateUserShowFlag', {
        type: 'POST',
        useJson: true,
        params: {
          companyId,
          ...params,
        },
      });
      return data;
    },

    // 企业新增配置 点餐设置
    async updateOrderSetFlag(companyId, params) {
      const data = await fetch('/saasmerchant/web/fscompany/updateOrderSetFlag', {
        type: 'POST',
        useJson: true,
        params: {
          companyId,
          ...params,
        },
      });
      return data;
    },

    // 到店付设置
    async updateQuickPayFlag(params) {
      const data = await fetch('/saasmerchant/web/fscompany/quickpay/updateQuickPayFlag', {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },

    // 到店付已关联门店
    async getCompanyQuickPaySubShopList(params) {
      const data = await fetch(
        '/saasmerchant/web/fscompany/quickpay/getCompanyQuickPaySubShopList',
        {
          type: 'POST',
          useJson: true,
          params,
        },
      );
      return data;
    },
    // 更新到店付距离限制
    async updateQuickPayDistanceLimit(params) {
      const data = await fetch('/saasmerchant/web/fscompany/quickpay/updateQuickPayDistanceLimit', {
        params,
        type: 'POST',
        useJson: true,
      });
      return data;
    },
  }),
};

export default model;
